// keycloak.js
import Keycloak from 'keycloak-js';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import router from './router';
import accessroute from './ConstantRoute'
import apiUrl from './constants'
import constantVariable from './constantVariable';


let initOptions = {
    url: apiUrl.kavach_url,
    realm: 'xpressbees',
    clientId: 'clt-crm-ui',
};

let keycloak = new Keycloak(initOptions);

const initKeycloak = () => {
    // ADI 7449 -- added if block if path anme conatins adi keyword it will force push login page -- start
    const currentPath = window.location.hash
      ? window.location.hash.replace("#", "")
      : window.location.pathname;

    if (currentPath.includes("/adi")) {
      return;
    }
    // ADI 7449 -- end
    keycloak
        .init({ onLoad: initOptions.onLoad })
        .then((auth) => {
            let isLoggedIn = window.localStorage.getItem('isLoggedIn');
            if (!auth && !isLoggedIn) {
                console.error("Authentication failed, initiating login...");
                router.push('/login');
            } else if (!auth) {
                keycloak.login()
            } else {
                window.localStorage.setItem('userToken', keycloak.token);
                // Fetch permissions and handle user details after successful authentication
                fetchPermissions();
                // // Set up token refresh interval
                // setupTokenRefresh();
            }
        })
        .catch((error) => {
            console.error(error);
            console.error("Authentication Failed");
        });
};

const fetchPermissions = () => {
    const userToken = keycloak.token;
    const headers = {
        'accept': 'application/json',
        'authorization': `Bearer ${userToken}`,
        'versionnumber': 'v2',
        'CSRF-Token': constantVariable.CSRF_TOKEN
    };
    const params = {
        clients: 'clt-crm-service',
    };
    axios.get(apiUrl.authservice_url + 'token', { headers, params })
        .then(async response => {
            if (response && response.status == 200) {
            const input = response.data["clt-crm-service"].permissions;
            const transformedData = transformToOutput(input);
            const userdetails = await getUserDetails(); // Assuming you have a method to get user details
            const permissionEncrypt = CryptoJS.AES.encrypt(JSON.stringify(transformedData), "Key");
            const userdetailEncrypt = CryptoJS.AES.encrypt(JSON.stringify(userdetails), "Key");
            var userData = userdetails[0];
            var rolename = userdetails[0].roles[0].rolename;
            let userReporting = Array();
            let isLoggedIn = window.localStorage.getItem('isLoggedIn');
            if (!isLoggedIn || isLoggedIn == 'false') {
                await getUserSubDepartmentList(userData.userid);
                await getHubAcessOfUser(userData.userid);
                await getUserClientList(userData.userid);
                userReporting.push(userData.userid);
                if (rolename == 'Admin') {
                    userReporting = 'admin';
                } else {
                    let reportingPersons = await getReportingPersonList(userData.userid);
                    if (undefined === reportingPersons) {
                        userReporting = userData.userid;
                    } else {
                        reportingPersons.push(userData.userid);
                        userReporting = reportingPersons.join();
                    }
                }
                // Store the encrypted permissions and user details in local storage
                window.localStorage.setItem('permissiondata', permissionEncrypt);
                window.localStorage.setItem('userdetail', userdetailEncrypt);
                window.localStorage.setItem('isLoggedIn', true);
                window.localStorage.setItem('userReporting', userReporting);
                window.localStorage.setItem("sebDepartment", "");
                window.localStorage.setItem("lastLoginDate", new Date().toISOString().split("T")[0]);
            }
            const currentURL = window.location.href;
            const path = new URL(currentURL).hash.replace('#', '');

            // Redirect to the desired route
            if (!isLoggedIn || path.toString() == '/login') {
                router.push(transformedData[0].url);
            } else {
                router.push(path.toString());
            }
            }else{
                let msg = 'There is some issue in Kavach -token. Please connect with the Kavach team.';
                console.error(msg);
                alert(msg);
                keycloak.logout();
            }
        })
        .catch(error => {
            console.error("Error fetching permissions:", error);
            alert("You do not have appropriate CRM Application access in Kavach. Please connect with the Kavach team.");
            keycloak.logout();
        });
};

const transformToOutput = (input) => {
    let scopedata = [];
    let result = [];
    // Iterate through each permission in CLT-CRM data.permissions
    input.forEach((permission) => {
        // Check if rsname is equal to "CLT-CRM"
        if (permission.rsname === "CLTCRM") {
            // Iterate through each scope and keep only the leftmost part before ":"
            let leftmostParts = permission.scopes.map((scope) => scope.split(":")[0]);
            // Push the leftmost parts into scopedata
            scopedata.push(...leftmostParts);
        }
    });
    if (scopedata.length === 0) {
        // Display "Access Denied" alert
        alert("You Does not have access for the given application, You will automatically redirected logout page!");
        keycloak.logout()
    }
    let accessurls = accessroute.accessurls
    // Iterate through each item in scopedata
    accessurls.forEach((accessUrlObj) => {
        // Check if there are children
        scopedata.forEach((url) => {
            if (url === accessUrlObj.kavachurl) {
                if (accessUrlObj.children && accessUrlObj.children.length > 0) {
                    // Filter the children based on matching kavachurl with scopedata
                    accessUrlObj.children = accessUrlObj.children.filter((childaccessUrlObj) => {
                        return scopedata.includes(childaccessUrlObj.kavachurl);
                    });
                }
                result.push(accessUrlObj);
            }
        })
    });

    return result;
};

const getUserDetails = async () => {
    try {
        const userToken = keycloak.token;
        const decodedToken = decodeJwt(userToken);
        let userrole = decodedToken.resource_access["clt-crm-service"].roles;
        if (userrole && userrole.length == 1) {

        }
        else {
            alert("You do not have appropriate CRM Role access in Kavach. Please connect with the Kavach team.");
            keycloak.logout();
        }
        userrole = userrole[0];
        const apiheaders = {
            'Content-Type': 'application/json',
            'authorization': `Bearer ${userToken}`,
            'versionnumber': 'v2',
            'CSRF-Token': constantVariable.CSRF_TOKEN
        };
        const response = await fetch(apiUrl.authservice_url + 'migration/getUserDetailsWithToken?utype=2', {
            method: 'POST',
            headers: apiheaders,
        });
        if (!response.ok) {
            alert("You do not have appropriate CRM Application access in Kavach. Please connect with the Kavach team");
            keycloak.logout();
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const responcedetails = await response.json();
        let userdata = responcedetails["userdetails"]
        const userdetails = [
            {
                "userid": (userdata.userid).toString(),
                "OldDeliveryUserOrUserId": userdata.oldDeliveryUserOrUserId,
                "username": userdata.username,
                "email": userdata.email,
                "EmployeeID": userdata.employeeID,
                "FirstName": userdata.firstName,
                "MiddleName": userdata.middleName,
                "LastName": userdata.lastName,
                "MobileNumber": userdata.mobileNumber,
                "PhoneNumber": userdata.phoneNumber,
                "clientid": userdata.clientId,
                "VendorId": userdata.vendorId,
                "DepartmentID": userdata.departmentID,
                "DesignationID": userdata.designationID,
                "OutSourcingID": userdata.outSourcingID,
                "HubId": userdata.hubId,
                "IsSR": userdata.isSR,
                "utype": userdata.utype,
                "roles": [
                    {
                        "rolename": userrole
                    }
                ]
            }]
        return userdetails;
    } catch (error) {
        let msg = 'There is some issue in Kavach -' + error.toString() + '. Please connect with the Kavach team.';
        console.error(msg);
        alert(msg);
        keycloak.logout();
        throw error; // Propagate the error to the caller
    }
};

function decodeJwt(jwtToken) {
    const base64Url = jwtToken.split('.')[1]; // Extract the second part of the token (payload)
    const base64 = base64Url.replace('-', '+').replace('_', '/'); // Replace URL-safe characters
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join('')); // Decode base64 and handle URL encoding
    return JSON.parse(jsonPayload); // Parse JSON
}

const getReportingPersonList = async (id) => {
    try {
        const userToken = keycloak.token;
        const headers = {
            'accept': 'application/json',
            'authorization': `Bearer ${userToken}`,
            'versionnumber': 'v2',
            'CSRF-Token': constantVariable.CSRF_TOKEN
        };
        const result = await axios({
            method: 'POST',
            url: `${apiUrl.api_url}getReportingPersonList`,
            data: {
                userid: id
            },
            headers: headers
        });

        const resultDataCrm = result.data.data.data.results;
        if (result.status) {
            const resultData = resultDataCrm;
            return resultData;
        } else {
            const msg = resultDataCrm.msg;
            alert('Error:' + msg);
            keycloak.logout()
            throw error; // Propagate the error to the caller
        }
    } catch (error) {
        const msg = ' Api - getReportingPersonList';
        alert('Error occurred while fetching' + msg);
        keycloak.logout()
        throw error; // Propagate the error to the caller
    }
};

const getUserSubDepartmentList = async (id) => {
    try {
        const userToken = keycloak.token;
        const headers = {
            'accept': 'application/json',
            'authorization': `Bearer ${userToken}`,
            'versionnumber': 'v2',
            'CSRF-Token': constantVariable.CSRF_TOKEN
        };
        window.localStorage.setItem('userSubDepartment', "");
        let input = {
            UserId: id
        };
        const result = await axios({
            method: "POST",
            url: `${apiUrl.api_url}getUserSubDepartmentList`,
            headers: headers,
            data: input
        });
        if (result.data.data.data.code === 200) {
            const subDepartment = result.data.data.data.data[0].SubdepartmentID;
            const subDepartmentObj = [];
            window.localStorage.setItem("userSubDepartmentId", "");
            if (subDepartment) {
                for (let i = 0; i < subDepartment.length; i++) {
                    if (subDepartment[i].SubdepartmentID && subDepartment[i].SubdepartmentID !== 29) {
                        const obj = {
                            value: subDepartment[i].SubdepartmentID,
                            text: subDepartment[i].Subdepartment
                        };
                        subDepartmentObj.push(obj);
                        window.localStorage.setItem("userSubDepartmentId", JSON.stringify(obj));
                    }
                }
            }
            window.localStorage.setItem('userSubDepartment', JSON.stringify(subDepartmentObj));
        } else {
            const msg = result.data.data.data.error;
            alert('Error:' + msg);
            keycloak.logout()
            throw error; // Propagate the error to the caller
        }
    } catch (error) {
        const msg = ' Api - getUserSubDepartmentList';
        alert('Error occurred while fetching' + msg);
        keycloak.logout()
        throw error; // Propagate the error to the caller
    }
};

const getHubAcessOfUser = async (id) => {
    try {
        const userToken = keycloak.token;
        const headers = {
            'accept': 'application/json',
            'authorization': `Bearer ${userToken}`,
            'versionnumber': 'v2',
            'CSRF-Token': constantVariable.CSRF_TOKEN
        };
        window.localStorage.setItem('userhubList', "");
        let input = {
            userid: id.toString()
        };
        const hubListObj = [];
        const result = await axios({
            method: "POST",
            url: `${apiUrl.api_url}getHubAcessOfUser`,
            headers: headers,
            data: input
        });
        if (result.data.data.data.code === 200) {
            const hubList = result.data.data.data.data.hubaccess;
            window.localStorage.setItem("userhubList", "");
            if (hubList) {
                for (let i = 0; i < hubList.length; i++) {
                    const obj = {
                        value: hubList[i].HubID,
                        text: hubList[i].HubName
                    };
                    hubListObj.push(obj);
                }
            }
            window.localStorage.setItem('userhubList', JSON.stringify(hubListObj));
        }
    } catch (error) {
        const msg = ' Api - getHubAcessOfUser';
        alert('Error occurred while fetching' + msg);
        keycloak.logout()
        throw error; // Propagate the error to the caller
    }
};

const getUserClientList = async (id) => {
    try {
        const userToken = keycloak.token;
        const headers = {
            'accept': 'application/json',
            'authorization': `Bearer ${userToken}`,
            'versionnumber': 'v2',
            'CSRF-Token': constantVariable.CSRF_TOKEN
        };
        let input = {
            userid: id.toString()
        };
        const userclientObj = [];
        const userClientName = [];
        window.localStorage.setItem('userclientList', []);
        window.localStorage.setItem('userclientNames', []);
        let clientNameData = "";
        const result = await axios({
            method: "POST",
            url: `${apiUrl.api_url}getUserClientList`,
            headers: headers,
            data: input
        });
        if (result.data.data.data.code === 200) {
            const userclient = result.data.data.data.data.userclient;
            window.localStorage.setItem("userclientList", "");
            if (userclient) {
                if (userclient[0].CompanyName == "ALL") {
                    const resultAllClientList = getAllClientList();
                    if (resultAllClientList && resultAllClientList.length > 0) {
                        userclient = resultAllClientList;
                    }
                    const obj = {
                        ClientMasterID: 0,
                        CompanyName: 'ALL'
                    };
                    userclientObj.push(obj);
                }
                for (let i = 0; i < userclient.length; i++) {
                    const companyNameObjstr = userclient[i].CompanyName;
                    if (companyNameObjstr) {
                        const companyNameObj = companyNameObjstr.replace(/'/g, "''");
                        userClientName.push(companyNameObj);
                        const obj = {
                            ClientMasterID: userclient[i].ClientMasterID,
                            CompanyName: userclient[i].CompanyName
                        };
                        userclientObj.push(obj);
                    } else {
                        console.log("companyNameObjstr  else " + companyNameObjstr)
                    }
                }
                clientNameData = userClientName.length ? ("'" + userClientName.join("', '") + "'") : '';
            }
            window.localStorage.setItem('userclientNames', clientNameData);
            window.localStorage.setItem('userclientList', JSON.stringify(userclientObj));
        }
    } catch (error) {
        const msg = ' Api - getUserClientList';
        alert('Error occurred while fetching' + msg);
        keycloak.logout()
        throw error; // Propagate the error to the caller
    }
};

const getAllClientList = () => {
    try {
        return new Promise(async (resolve, reject) => {
            const userToken = keycloak.token;
            const headers = {
                'accept': 'application/json',
                'authorization': `Bearer ${userToken}`,
                'versionnumber': 'v2',
                'CSRF-Token': constantVariable.CSRF_TOKEN
            };
            await axios({
                method: "POST",
                'url': apiUrl.api_url + 'getClientList',
                headers: headers,
                'data': {
                    BusinessFlow: "Forward",
                    BusinessService: "Delivery"
                },
            }).then(
                result => {
                    var data = result.data.data.data.data;
                    let clientData = [];
                    if (data && data.length) {
                        for (var i = 0; i < data.length; i++) {
                            clientData.push({
                                ClientMasterID: parseInt(data[i].ClientBusinessAccountId),
                                CompanyName: data[i].AccountName
                            });
                        }
                    } else {
                        console.log("data not found");
                    }
                    resolve(clientData);
                },
                error => {
                    let msg = error;
                    alert('Error:' + msg);
                    keycloak.logout()
                    throw error; // Propagate the error to the caller
                });
        });
    } catch (error) {
        let msg = error + " Api - getAllClientList";
        alert('Error occurred while fetching' + msg);
        keycloak.logout()
        throw error; // Propagate the error to the caller
    }
};

// Function to decode JWT token and get its expiration time
function getTokenExpiration(token) {

    const payloadBase64 = token.split('.')[1];
    const payload = atob(payloadBase64);
    const parsedPayload = JSON.parse(payload);
    return parsedPayload.exp;
}

// Function to check and refresh the token if necessary
async function checkAndRefreshToken() {
    const token = window.localStorage.getItem('userToken');
    if (!token || token == 'undefined') {
        initKeycloak();
    }
    const tokenExpiration = getTokenExpiration(token);
    const currentTime = Math.floor(Date.now() / 1000);

    // Check if the token is within the next 5 minutes of expiration
    const timeToExpiry = tokenExpiration - currentTime;
    if (timeToExpiry <= 5 * 60) {
        try {
            initKeycloak();
        } catch (error) {
            console.error("Error refreshing token:", error);
            keycloak.logout();
        }
    }
}

// Function to set up an interval to check token expiry and refresh if necessary
function AppStartUp() {

    let isLoggedIn = window.localStorage.getItem('isLoggedIn');
    if (!isLoggedIn || isLoggedIn == 'false') {
        // Initialize the Vue instance after the keycloak initialization
        initKeycloak();
    }else{
    // Perform an immediate check and refresh
    checkAndRefreshToken();
    }
    // Set up an interval to check the token every minute
    setInterval(() => {
        checkAndRefreshToken();
    }, 60000); // Check every minute
}


AppStartUp();


// Add the function as a method to the keycloak instance
keycloak.checkAndClearLocalStorageIfMissed = function() {
  const today = new Date().toISOString().split("T")[0];
  
  let lastLoginDate = localStorage.getItem("lastLoginDate");

  // If lastLoginDate is null, set it to today (first login of the day)
  if (!lastLoginDate) {
    localStorage.setItem("lastLoginDate", today);
    lastLoginDate = today;
  }
  console.log("lastLoginDate-------------------------------", lastLoginDate);
  console.log("today-------------------------------", today);

  // Only clear if it's after 11:59 and user logged in today
  if (lastLoginDate !== today) {
      localStorage.clear();
      keycloak.logout();
      localStorage.setItem("lastLoginDate", today);
      console.log("localStorage cleared on page load fallback");
    
  } else {
    console.log("No need to clear localStorage yet.");
  }
}

export default keycloak;



// WEBPACK FOOTER //
// ./src/Keycloak.js